import { createElement } from "react";
import { Trans } from "react-i18next";
import { put } from "../../../common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IChangeRiskAssessmentVersionLockedDialog } from "./ChangeRiskAssessmentVersionLockedDialog";
import { RiskVersionViewModel } from "../riskAssessmentVersions/RiskAssessmentVersions.types";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useChangeRiskAssessmentVersionLockedDialogHooks(props: IChangeRiskAssessmentVersionLockedDialog) {
    const snackbar = useDotLegalSnackbar();

    const changeLockMutation = useDotLegalMutation(changeLocked);

    const changeIsLocked = (version: RiskVersionViewModel) => {
        changeLockMutation.mutateAsync(version, {
            onSuccess: () => {
                snackbar.show(
                    createElement(Trans, {
                        i18nKey: version.isLocked ? "riskAssessmentVersionIsUnLocked" : "riskAssessmentVersionIsLocked",
                        values: { name: version.name },
                    })
                );
                props.onSave();
            },
        });
    };

    function changeLocked(version: RiskVersionViewModel) {
        return put<string>(`/riskassesmentversions/${version.id}/changeLockStatus`, !version.isLocked);
    }

    return {
        changeIsLocked,
        inProgress: changeLockMutation.isLoading,
    };
}
